/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../common";
import type { Buyback, BuybackInterface } from "../Buyback";

const _abi = [
  {
    inputs: [],
    name: "ECExchangeAmountIsTooLow",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "prod1",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "denominator",
        type: "uint256",
      },
    ],
    name: "FixedPointMathMulDivOverflow",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "userId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "mfsAmount",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "daiAmount",
        type: "uint256",
      },
    ],
    name: "BuyBack",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "oldBuyBackRate",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newBuyBackRate",
        type: "uint256",
      },
    ],
    name: "BuyBackRateChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "userId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "tokenIn",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "tokenOut",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amountIn",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amountOut",
        type: "uint256",
      },
    ],
    name: "DebtRepayment",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "userId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "tokenIn",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "tokenOut",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amountIn",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amountOut",
        type: "uint256",
      },
    ],
    name: "Exchange",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "version",
        type: "uint8",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "mfsAmount",
        type: "uint256",
      },
    ],
    name: "buyBack",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "buyBackRate",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "userId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "tokenIn",
        type: "address",
      },
      {
        internalType: "address",
        name: "tokenOut",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "exchangeExactTo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "userId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "tokenIn",
        type: "address",
      },
      {
        internalType: "address",
        name: "tokenOut",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "exchangeToExact",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenIn",
        type: "address",
      },
      {
        internalType: "address",
        name: "tokenOut",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "exchangeToExact",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenFrom",
        type: "address",
      },
      {
        internalType: "address",
        name: "tokenTo",
        type: "address",
      },
    ],
    name: "getRate",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getRegistry",
    outputs: [
      {
        internalType: "contract IRegistryContract",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getSwapContract",
    outputs: [
      {
        internalType: "contract IForceSwap",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IRegistryContract",
        name: "_getRegistry",
        type: "address",
      },
      {
        internalType: "contract IForceSwap",
        name: "_getSwapContract",
        type: "address",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "newBuyBackRate",
        type: "uint256",
      },
    ],
    name: "setBuyBackRate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type BuybackConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: BuybackConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class Buyback__factory extends ContractFactory {
  constructor(...args: BuybackConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<Buyback> {
    return super.deploy(overrides || {}) as Promise<Buyback>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): Buyback {
    return super.attach(address) as Buyback;
  }
  override connect(signer: Signer): Buyback__factory {
    return super.connect(signer) as Buyback__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): BuybackInterface {
    return new utils.Interface(_abi) as BuybackInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): Buyback {
    return new Contract(address, _abi, signerOrProvider) as Buyback;
  }
}
